export var calculateAmountOfItemsPerPage = function calculateAmountOfItemsPerPage(_ref) {
  var wrapperWidth = _ref.wrapperWidth,
    itemMinWidth = _ref.itemMinWidth,
    maxItemsPerPage = _ref.maxItemsPerPage;
  var amount = Math.floor(wrapperWidth / itemMinWidth);
  return amount > maxItemsPerPage ? maxItemsPerPage : amount;
};